<div class="content">

    <mat-card appearance="outlined">
        <mat-card-header>
            <mat-icon class="card-header-icon" mat-card-avatar>view_module</mat-icon>
            <mat-card-title>Modules</mat-card-title>
            <mat-card-subtitle>List of predefined modules</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
                <ng-container matColumnDef="moduleId">
                    <th mat-header-cell *matHeaderCellDef> Module Id </th>
                    <td mat-cell *matCellDef="let module"> {{module.id}} </td>
                </ng-container>

                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef> Name </th>
                    <td mat-cell *matCellDef="let module"> {{module.name}} </td>
                </ng-container>

                <ng-container matColumnDef="description">
                    <th mat-header-cell *matHeaderCellDef> Description </th>
                    <td mat-cell *matCellDef="let module"> {{module.description}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </mat-card-content>
        <mat-card-actions align="end">
            <button mat-button>ADD NEW MODULE</button>
            <button mat-button disabled>EDIT</button>
            <button mat-button disabled>DELETE</button>
        </mat-card-actions>
    </mat-card>

</div>